import { Container } from '@/atoms';
import { CardService, Grid } from '@/molecules';

import { blockSpacing, sectionBgProps } from '@/utils';

/**
 * ComponentRevisadasServiciosList
 */
export const ComponentRevisadasServiciosList = ({
  servicios,
  FondoSeccion,
  Espaciado,
}: any) =>
  servicios.length > 0 ? (
    <Container
      wrapper
      className={blockSpacing(Espaciado, 'mt-6')}
      {...sectionBgProps(FondoSeccion)}
    >
      <Grid md={2} className="flex flex-col justify-center gap-4">
        {servicios.map((itm: any, index: number) => (
          <Grid.Item key={`ServicioEntity-${index}`}>
            <CardService
              logo={
                itm.Logo
                  ? {
                      alt: itm.Logo?.alternativeText,
                      src: itm.Logo?.url,
                      width: itm.Logo?.width,
                      height: itm.Logo?.height,
                    }
                  : undefined
              }
              title={itm.Titulo}
              description={itm.Descripcion}
              tag={itm?.Tag}
              theme="light"
            />
          </Grid.Item>
        ))}
      </Grid>
    </Container>
  ) : null;

ComponentRevisadasServiciosList.displayName = 'ComponentRevisadasServiciosList';
